import React from "react";
import { ModernSheet } from "components/common/ModernSheet/ModernSheet";
import { Button } from "components/common/buttons/Button";
import { CUSTOMER_SUCCESS_EMAIL } from "config/constant";

interface PermissionDeniedStateProps {
  isOpen: boolean;
  onClose: () => void;
  permissions: any;
}

export const PermissionDeniedState: React.FC<PermissionDeniedStateProps> = ({
  isOpen,
  onClose,
  permissions,
}) => {
  return (
    <ModernSheet
      isOpen={isOpen}
      onClose={onClose}
      title="Permission Denied"
      description="You don't have permission to create projects"
      size="xl"
      className="max-h-screen"
    >
      <div className="flex-1 p-6">
        <div className="text-center flex flex-col gap-4">
          <div className="text-danger text-6xl mb-4">⚠️</div>
          <h3 className="text-lg font-medium text-foreground">Permission Denied</h3>
          <p className="text-muted-foreground">
            {permissions.isDeactivated
              ? `Your account has been deactivated. Please contact ${CUSTOMER_SUCCESS_EMAIL}.`
              : permissions.isOneTimePurchase
                ? "You don't have available licenses or trials. Please purchase additional licenses to create new projects."
                : permissions.isSubscriptionExpired
                  ? "Your subscription has expired. Please renew to create new projects."
                  : "You have reached your project quota. Please upgrade your plan to create more projects."}
          </p>
          <div className="pt-4">
            <Button onClick={onClose} className="rounded-lg px-4 py-2">
              Close
            </Button>
          </div>
        </div>
      </div>
    </ModernSheet>
  );
};
